// Studyo Today Backend
// Package studyo.schools.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/attachment.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_attachment_kind } from "./attachment_kind_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/attachment.proto.
 */
export const file_studyo_today_schools_v1_resources_attachment = /*@__PURE__*/
  fileDesc("CjJzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvYXR0YWNobWVudC5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzIqwBCgpBdHRhY2htZW50Ej8KBGtpbmQYASABKA4yMS5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuQXR0YWNobWVudEtpbmQSDQoFdGl0bGUYAiABKAkSFQoNdGh1bWJuYWlsX3VybBgDIAEoCRILCgN1cmwYBCABKAkSEwoLZXh0ZXJuYWxfaWQYBSABKAkSFQoNZXh0ZXJuYWxfa2luZBgGIAEoCUIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_schools_v1_resources_attachment_kind]);

/**
 * Describes the message studyo.today.schools.v1.resources.Attachment.
 * Use `create(AttachmentSchema)` to create a new message.
 */
export const AttachmentSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_attachment, 0);

